import { render, staticRenderFns } from "./SemiRadialBarChart.vue?vue&type=template&id=13dc3526&scoped=true&"
import script from "./SemiRadialBarChart.vue?vue&type=script&lang=js&"
export * from "./SemiRadialBarChart.vue?vue&type=script&lang=js&"
import style0 from "./SemiRadialBarChart.vue?vue&type=style&index=0&id=13dc3526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dc3526",
  null
  
)

export default component.exports